import { createTheme, Theme } from "@mui/material";
import { RefineThemes } from "@refinedev/mui";

export const customTheme: Theme = createTheme({
  ...RefineThemes.Blue,
  palette: {
    background: {
      default: "#f5f5f5",
    },
    primary: {
      main: "#4832BB",
    },
    secondary: {
      main: "#FD6A1C",
    },
    text: {
      primary: "#000000",
      secondary: "#707070",
    },
  },
  components: {
    MuiInputLabel: {
      styleOverrides: {},
      defaultProps: {
        shrink: true, // Shrink the text label by default, prevent it overlapping with the value
      },
    },
  },
});
